import { useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";

const ReportUpgradePackage = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
 
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        { 
            dataIndex: 'store_name', 
            title: 'Cơ sở nâng cấp', 
            fixed:'left'
        },
        {
            dataIndex: 'store_paid_name',
            title: 'Cơ sở ban đầu',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            dataIndex: 'store_paid',
            title: 'Tổng tiền',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.store_paid) - Number(b.store_paid),
                multiple: 1,
            },
        }
    ];

    const handelExportData = () => {
        setShowLoading(true)
        var url = `api/reports-view/upgrade-cross?type=2&startDate=${props.startDate}&endDate=${props.endDate}&storeId=${props.store}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.open(res.data.data.url, '_blank');
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }

    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

  
    return (
        <>
            <div style={{ backgroundColor: "white" }}>
                
                <div className="border-bottom w-100 pb-2">
                    <div className="d-flex justify-content-between">
                        Bảng số liệu chi tiết
                        <Button size="middle" type="primary" onClick={handelExportData}>
                            <i className="fa-solid fa-file-excel mr-2"></i>Xuất Excel
                        </Button>
                    </div>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    // scroll={{ x: 'calc(700px + 50%)', y: 600 }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    onChange={handleChange}
                    rowKey="id" 
                    bordered
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
        </>
    )
}
export default ReportUpgradePackage